<template>
  <div>
    <v-form ref="form">
      <v-row>
        <v-col cols="12" sm="6">
          <BaseFormAutocompleteSelectable
            id-element="economicGroupLegacyImportation"
            placeholder="Selecione"
            v-model="form.grupo_economico"
            :items="currentAutoCompleteFilter"
            hide-no-data
            item-text="nome"
            item-value="id"
            validate-on-blur
            :return-object="true"
            :rules="[requiredInput, requiredValidEconomicGroup]"
            label-text="Grupo Econômico"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <BaseFormSelect
            id-element="typeFileLegacyImportation"
            placeholder="Selecionar"
            v-model="form.tipo_arquivo"
            required
            :rules="[requiredInput]"
            label-text="Escolha um Tipo de Importação"
            :items="itemsTypeLegacyImportation"
            item-text="nome"
            item-value="id"
            :return-object="true"
            validate-on-blur
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
          class="pl-sm-5 pb-5 pb-sm-0"
          v-if="form.tipo_arquivo"
        >
          <p
            class="mb-0 body-2 primary--text mt-sm-9"
            style="cursor: pointer;"
            @click="downloadTemplate"
          >
            <v-icon color="primary" size="14" class="pr-1">
              fa-file
            </v-icon>
            Download do Template
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <DropFile
            @selected-files="addFilesLegacy"
            :multiple="false"
            class="mb-5"
            v-if="withoutLegacy"
            format-files-acceptable=".xls,.xlsx"
          />
          <DocumentDataTable
            v-else
            :documents="form.legado"
            @preview-file="onPreviewFile"
            @remove-file="onRemoveFileLegacy"
          />
          <BaseErrorMessages
            v-if="errorMessages.length > 0"
            :error-messages="errorMessages"
          />
        </v-col>
      </v-row>
    </v-form>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <!-- <v-col cols="12" sm="4" md="3" xl="2" class="pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR'"
            class="pink white--text"
            width="100%"
          />
        </v-col> -->
        <v-col cols="12" sm="4" md="3" xl="2">
          <BaseButton
            v-html="'IMPORTAR'"
            class="secondary"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </BaseFooter>
    <ModalGenericCriticism
      v-model="modal"
      @close="closeModal"
      title="IMPORTAÇÃO SOLICITADA"
      :subtitle="subtitle"
      has-cancel-button
      text-cancel-button="SAIR"
      text="Sua solicitação entrou na fila para importação. É possível acompanhar o status e andamento na tela de Logs de Importação."
    />
  </div>
</template>
<script>
import DocumentsMixin from "@/mixins/DocumentsMixin";
import DocumentDataTable from "@/components/DocumentDataTable";
import DropFile from "@/components/DropFile";
import { requiredInput } from "@/utils/rules.js";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import _ from "lodash";
import ModalGenericCriticism from "@/modules/quotation/components/ModalGenericCriticism";
import PolicyMixin from "@/mixins/PolicyMixin";
const URL_POLICY =
  "https://fileshare.lockton.com.br/download.php?id=2455&token=QUfekiWfXGC1cXSwVanbNhpbuoRPVLz1&download";
const URL_ENDORSEMENT =
  "https://fileshare.lockton.com.br/download.php?id=2454&token=vEgHNykBbAOYos7ixsYfrJYGte42T4uo&download";
const MOCK_FORM = {
  legado: [],
  grupo_economico: null,
  tipo_arquivo: null
};
export default {
  mixins: [LoadingRequest, DocumentsMixin, PolicyMixin],
  components: {
    DropFile,
    DocumentDataTable,
    ModalGenericCriticism
  },
  data: () => ({
    currentAutoCompleteFilter: [],
    subtitle: null,
    modal: false,
    timeout: null,
    form: {
      legado: [],
      grupo_economico: null,
      tipo_arquivo: null
    },
    errorMessages: [],
    requiredInput,
    numberLegacy: null
  }),
  created() {
    this.fetchAutocompleteFilter();
  },
  computed: {
    ...mapState("legacy_importation", ["itemsTypeLegacyImportation"]),
    withoutLegacy() {
      return this.form.legado.length == 0;
    },
    requiredValidEconomicGroup() {
      return (
        this.validateFilterEconomicGroup() ||
        "É preciso selecionar um grupo econômico válido"
      );
    }
  },
  methods: {
    ...mapActions("legacy_importation", [
      "requestAutoCompleteEconomicGroup",
      "requestNewLegacyImportation"
    ]),
    fetchAutocompleteFilter() {
      this.withLoading(
        this.requestAutoCompleteEconomicGroup().then(data => {
          this.currentAutoCompleteFilter = data;
        })
      );
    },
    async submit() {
      if (!this.validate()) return;
      this.withLoading(
        this.requestNewLegacyImportation(
          await this.getPayloadLegacyImportation()
        ).then(data => {
          this.modal = true;
          this.subtitle = `Número da Solicitação: ${data.numero_protocolo}`;
          this.numberLegacy = data.numero_protocolo;
        })
      );
    },
    async getPayloadLegacyImportation() {
      let payload = _.cloneDeep(this.form);
      payload.legado = await this.submitFiles(this.form.legado);
      payload.arquivo = payload.legado[0];
      return payload;
    },
    validate() {
      this.errorMessages = this.withoutLegacy
        ? ["É preciso anexar o arquivo"]
        : [];
      return !this.withoutLegacy && this.$refs.form.validate();
    },
    addFilesLegacy(files) {
      this.form.legado = this.addFiles(this.form.legado, files);
    },
    onRemoveFileLegacy() {
      this.form.legado = [];
    },
    validateFilterEconomicGroup() {
      return (
        !this.form.grupo_economico || Boolean(this.form.grupo_economico?.id)
      );
    },
    closeModal(value) {
      this.modal = false;
      this.form = _.cloneDeep(MOCK_FORM);
      if (value) {
        this.$emit("changeTab", this.numberLegacy);
      }
    },
    downloadTemplate() {
      let urlDownload =
        this.form.tipo_arquivo.id == "apolice" ? URL_POLICY : URL_ENDORSEMENT;
      window.open(urlDownload);
    }
  }
};
</script>
